import React from 'react'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'

function LoginBox ({ title, smallTitle = false, children }) {
  const { localize } = useLocalization()

  const renderTopHeader = () => {
    if (context.isInternalApp()) {
      return <div className='top-header'>{localize('Documentation.InternalWeb')}</div>
    }
  }

  return (
    <div className='login-box'>
      {renderTopHeader()}
      <h2 className='pb-2'>
        <img src='/logo.png' alt={localize('Security.LogoAlt')} /> {smallTitle ? <small>{localize(title)}</small> : localize(title)}
      </h2>
      {children}
    </div>
  )
}

export {
  LoginBox
}



// WEBPACK FOOTER //
// ./src/components/auth/loginBox.js